import { forwardRef } from 'react';

import { languageStrings } from '@/l18n/de';

type ButtonProps = {
	ariaLabel: string;
	children: React.ReactNode;
	className: string;
	disabled?: boolean;
	onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
	role?: string;
	type: React.ButtonHTMLAttributes<HTMLButtonElement>['type'];
};

const Button = forwardRef<HTMLButtonElement, ButtonProps>((props: ButtonProps, ref) => {
	return (
		<>
			<span
				className="sr-only"
				role="status"
			>
				{props.disabled ? languageStrings.buttons.loading : ''}
			</span>

			<button
				aria-disabled={props.disabled}
				aria-label={props.ariaLabel}
				className={props.className ? `form--button ${props.className}` : 'form--button'}
				disabled={props.disabled || false}
				key="button"
				onClick={props.onClick}
				ref={ref}
				role={props.role}
				type={props.type === 'submit' ? 'submit' : 'button'}
			>
				{props.children}
			</button>
		</>
	);
});

export { Button };
